import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class LeafTemperatureAttribute extends Sensor {
  public leafTemperatureChart: any;
  private leafTemperatureSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.leafTemperatureChart = null;
    this.leafTemperatureSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.leafTemperatureSensor, position);
      this.leafTemperatureSensor[position].push([timestamp, element.leafTemperature]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredLeafTemperature = this.leafTemperatureSensor.filter(series => series.length > 0);

    const positionNodeLeafTemperature = this.leafTemperatureSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.leafTemperatureChart = this.getConfigChar(
      'leafTemperature',
      this.getChartSeriesNewNode('Sensor', filteredLeafTemperature, positionNodeLeafTemperature),
      this.getRanges('leafTemperature'),
      this.getLimits('leafTemperature')
    );
  }

  public hasLeafTemperatureSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.leafTemperatureSensor.length &&
      this.leafTemperatureSensor[index].length > 0
    );
  }

  public getLeafTemperatureSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.leafTemperatureSensor.length) {
      const sensorData = this.leafTemperatureSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Temperatura de la hoja', value: 'leafTemperature' }
    ];
  }
}
